import React, { FC } from 'react';
import { SvgWithTooltip } from './SvgWithTooltip';
import { SVGTooltipProps } from '../../utils';

export const RemoteWork: FC<SVGTooltipProps> = ({ onClick, divClassName, tooltip }) => (
  <SvgWithTooltip 
    onClick={onClick}
    divClassName={divClassName}
    tooltip={tooltip}
  >
    <svg 
      width="100%" 
      height="100%" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle 
        cx="12" 
        cy="12" 
        r="12" 
        fill="#4285F4"
      />
      <path 
        d="M7.125 17.8333H9.9375V12.9722H14.0625V17.8333H16.875V10.25L12 6.45833L7.125 10.25V17.8333ZM6 19V9.66667L12 5L18 9.66667V19H12.9375V14.1389H11.0625V19H6Z" 
        fill="white" 
        fillOpacity="0.94"
      />
    </svg>
  </SvgWithTooltip>
);
